/**
 * Essential Eight Control IDs
 * Complete list of all E8 controls for dropdown picker
 */

export const CONTROL_IDS = {
  // Application Control (ML1, ML2, ML3)
  'ML1-AC-01': 'ML1 - Application Control - Baseline Implementation',
  'ML1-AC-02': 'ML1 - Application Control - User Access Controls',
  'ML1-AC-03': 'ML1 - Application Control - Allowlisting Rules',
  'ML2-AC-01': 'ML2 - Application Control - Enhanced Implementation',
  'ML2-AC-02': 'ML2 - Application Control - Advanced Blocking',
  'ML2-AC-03': 'ML2 - Application Control - Script Control',
  'ML3-AC-01': 'ML3 - Application Control - Mature Implementation',
  'ML3-AC-02': 'ML3 - Application Control - Zero Trust Application',
  'ML3-AC-03': 'ML3 - Application Control - Dynamic Analysis',

  // Patch Applications (ML1, ML2, ML3)
  'ML1-PA-01': 'ML1 - Patch Applications - Critical Security Updates',
  'ML1-PA-02': 'ML1 - Patch Applications - Update Schedule',
  'ML1-PA-03': 'ML1 - Patch Applications - Vulnerability Assessment',
  'ML2-PA-01': 'ML2 - Patch Applications - Enhanced Patching Process',
  'ML2-PA-02': 'ML2 - Patch Applications - Automated Deployment',
  'ML2-PA-03': 'ML2 - Patch Applications - Risk-Based Prioritization',
  'ML3-PA-01': 'ML3 - Patch Applications - Mature Patch Management',
  'ML3-PA-02': 'ML3 - Patch Applications - Zero-Day Protection',
  'ML3-PA-03': 'ML3 - Patch Applications - Continuous Integration',

  // Configure Microsoft Office Macro Settings (ML1, ML2, ML3)
  'ML1-MS-01': 'ML1 - Microsoft Office Macros - Basic Security Settings',
  'ML1-MS-02': 'ML1 - Microsoft Office Macros - User Training',
  'ML1-MS-03': 'ML1 - Microsoft Office Macros - Policy Implementation',
  'ML2-MS-01': 'ML2 - Microsoft Office Macros - Enhanced Protection',
  'ML2-MS-02': 'ML2 - Microsoft Office Macros - Advanced Analysis',
  'ML2-MS-03': 'ML2 - Microsoft Office Macros - Centralized Management',
  'ML3-MS-01': 'ML3 - Microsoft Office Macros - Mature Implementation',
  'ML3-MS-02': 'ML3 - Microsoft Office Macros - Behavioral Analysis',
  'ML3-MS-03': 'ML3 - Microsoft Office Macros - Zero Trust Architecture',

  // User Application Hardening (ML1, ML2, ML3)
  'ML1-UH-01': 'ML1 - User Application Hardening - Basic Configuration',
  'ML1-UH-02': 'ML1 - User Application Hardening - Security Features',
  'ML1-UH-03': 'ML1 - User Application Hardening - Update Management',
  'ML2-UH-01': 'ML2 - User Application Hardening - Enhanced Security',
  'ML2-UH-02': 'ML2 - User Application Hardening - Advanced Configuration',
  'ML2-UH-03': 'ML2 - User Application Hardening - Monitoring & Logging',
  'ML3-UH-01': 'ML3 - User Application Hardening - Mature Implementation',
  'ML3-UH-02': 'ML3 - User Application Hardening - Continuous Assessment',
  'ML3-UH-03': 'ML3 - User Application Hardening - Adaptive Controls',

  // Restrict Administrative Privileges (ML1, ML2, ML3)
  'ML1-RA-01': 'ML1 - Restrict Admin Privileges - Basic Admin Controls',
  'ML1-RA-02': 'ML1 - Restrict Admin Privileges - User Account Management',
  'ML1-RA-03': 'ML1 - Restrict Admin Privileges - Privilege Documentation',
  'ML2-RA-01': 'ML2 - Restrict Admin Privileges - Enhanced Controls',
  'ML2-RA-02': 'ML2 - Restrict Admin Privileges - Just-in-Time Access',
  'ML2-RA-03': 'ML2 - Restrict Admin Privileges - Privileged Access Management',
  'ML3-RA-01': 'ML3 - Restrict Admin Privileges - Mature Implementation',
  'ML3-RA-02': 'ML3 - Restrict Admin Privileges - Zero Standing Privileges',
  'ML3-RA-03': 'ML3 - Restrict Admin Privileges - Continuous Monitoring',

  // Patch Operating Systems (ML1, ML2, ML3)
  'ML1-PO-01': 'ML1 - Patch Operating Systems - Critical Updates',
  'ML1-PO-02': 'ML1 - Patch Operating Systems - Update Schedule',
  'ML1-PO-03': 'ML1 - Patch Operating Systems - Vulnerability Management',
  'ML2-PO-01': 'ML2 - Patch Operating Systems - Enhanced Process',
  'ML2-PO-02': 'ML2 - Patch Operating Systems - Automated Deployment',
  'ML2-PO-03': 'ML2 - Patch Operating Systems - Risk Assessment',
  'ML3-PO-01': 'ML3 - Patch Operating Systems - Mature Implementation',
  'ML3-PO-02': 'ML3 - Patch Operating Systems - Predictive Maintenance',
  'ML3-PO-03': 'ML3 - Patch Operating Systems - Continuous Integration',

  // Multi-factor Authentication (ML1, ML2, ML3)
  'ML1-MF-01': 'ML1 - Multi-factor Authentication - Basic Implementation',
  'ML1-MF-02': 'ML1 - Multi-factor Authentication - User Training',
  'ML1-MF-03': 'ML1 - Multi-factor Authentication - Policy Enforcement',
  'ML2-MF-01': 'ML2 - Multi-factor Authentication - Enhanced Security',
  'ML2-MF-02': 'ML2 - Multi-factor Authentication - Risk-Based Access',
  'ML2-MF-03': 'ML2 - Multi-factor Authentication - Advanced Methods',
  'ML3-MF-01': 'ML3 - Multi-factor Authentication - Mature Implementation',
  'ML3-MF-02': 'ML3 - Multi-factor Authentication - Adaptive Authentication',
  'ML3-MF-03': 'ML3 - Multi-factor Authentication - Continuous Verification',

  // Daily Backups (ML1, ML2, ML3)
  'ML1-DB-01': 'ML1 - Daily Backups - Basic Backup Strategy',
  'ML1-DB-02': 'ML1 - Daily Backups - Recovery Testing',
  'ML1-DB-03': 'ML1 - Daily Backups - Backup Monitoring',
  'ML2-DB-01': 'ML2 - Daily Backups - Enhanced Strategy',
  'ML2-DB-02': 'ML2 - Daily Backups - Automated Recovery',
  'ML2-DB-03': 'ML2 - Daily Backups - Offsite Storage',
  'ML3-DB-01': 'ML3 - Daily Backups - Mature Implementation',
  'ML3-DB-02': 'ML3 - Daily Backups - Continuous Data Protection',
  'ML3-DB-03': 'ML3 - Daily Backups - Intelligent Recovery'
};

/**
 * Get grouped control IDs by category and maturity level
 */
export const getGroupedControlIds = () => {
  const grouped = {};
  
  Object.entries(CONTROL_IDS).forEach(([id, description]) => {
    const [maturity, category] = id.split('-');
    const categoryMap = {
      'AC': 'Application Control',
      'PA': 'Patch Applications', 
      'MS': 'Microsoft Office Macros',
      'UH': 'User Application Hardening',
      'RA': 'Restrict Administrative Privileges',
      'PO': 'Patch Operating Systems',
      'MF': 'Multi-factor Authentication',
      'DB': 'Daily Backups'
    };
    
    const categoryName = categoryMap[category] || category;
    
    if (!grouped[categoryName]) {
      grouped[categoryName] = {};
    }
    
    if (!grouped[categoryName][maturity]) {
      grouped[categoryName][maturity] = [];
    }
    
    grouped[categoryName][maturity].push({ id, description });
  });
  
  return grouped;
};

/**
 * Get control IDs for a specific category
 */
export const getControlIdsByCategory = (category) => {
  return Object.entries(CONTROL_IDS)
    .filter(([id]) => id.includes(category))
    .map(([id, description]) => ({ id, description }));
};

/**
 * Get control IDs for a specific maturity level
 */
export const getControlIdsByMaturity = (maturity) => {
  return Object.entries(CONTROL_IDS)
    .filter(([id]) => id.startsWith(maturity))
    .map(([id, description]) => ({ id, description }));
};

/**
 * Search control IDs by text
 */
export const searchControlIds = (searchText) => {
  const search = searchText.toLowerCase();
  return Object.entries(CONTROL_IDS)
    .filter(([id, description]) => 
      id.toLowerCase().includes(search) || 
      description.toLowerCase().includes(search)
    )
    .map(([id, description]) => ({ id, description }));
};

export default CONTROL_IDS;